/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the StartSsoResponseParams interface.
 */
export function instanceOfStartSsoResponseParams(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
export function StartSsoResponseParamsFromJSON(json) {
    return StartSsoResponseParamsFromJSONTyped(json, false);
}
export function StartSsoResponseParamsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
export function StartSsoResponseParamsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
    };
}
